export default "__VITE_ASSET__ab06128f__"